import { render, staticRenderFns } from "./PhotoFactory.vue?vue&type=template&id=ba06adba&scoped=true"
import script from "./PhotoFactory.vue?vue&type=script&lang=js"
export * from "./PhotoFactory.vue?vue&type=script&lang=js"
import style0 from "./PhotoFactory.vue?vue&type=style&index=0&id=ba06adba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba06adba",
  null
  
)

export default component.exports